import type { LanguageDefinition } from 'types/documentServices';

export const shouldLanguageBeInvisible = (
  isInPreviewMode: boolean,
  language?: LanguageDefinition,
) => {
  return isInPreviewMode && language?.status === 'Inactive';
};
